import React, { memo, useCallback, useState } from "react";
import PropTypes from "prop-types";
import { BettoCard } from "../../../components/BettoCard";
import { BettoEmptyState } from "../../../components/BettoEmptyState";
import { BettoPrimaryButton } from "../../../components/BettoButton";
import styled from "styled-components";
import { BTTO_PROFILE_COLORS } from "../../../shared/elements";

const TabBar = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	flex-wrap: wrap;
	margin-bottom: 20px;
`;

const Tabs = styled.div`
	display: flex;
	gap: 4px;
	padding: 4px;
	border-radius: 8px;
	background: ${BTTO_PROFILE_COLORS.surfaceRaised};
`;

const Tab = styled.button`
	padding: 8px 14px;
	border: none;
	border-radius: 6px;
	background: ${({ $active }) => ($active ? BTTO_PROFILE_COLORS.surface : "transparent")};
	color: ${({ $active }) => ($active ? BTTO_PROFILE_COLORS.text : BTTO_PROFILE_COLORS.textMuted)};
	font-size: 13px;
	font-weight: 500;
	cursor: pointer;
	transition: background 0.2s ease;
`;

const PAYMENT_TABS = [
	{ id: "all", labelKey: "betto.profile.allCards" },
	{ id: "credit", labelKey: "betto.profile.creditCards" },
	{ id: "debit", labelKey: "betto.profile.debitCards" },
];

export const PaymentMethodsSection = memo(({ translate, history }) => {
	const [activeTab, setActiveTab] = useState("all");

	const handleAddMethod = useCallback(() => {
		history?.push("/profile/deposit");
	}, [history]);

	return (
		<BettoCard>
			<TabBar>
				<Tabs>
					{PAYMENT_TABS.map((tab) => (
						<Tab
							key={tab.id}
							type="button"
							$active={activeTab === tab.id}
							onClick={() => setActiveTab(tab.id)}>
							{translate(tab.labelKey)}
						</Tab>
					))}
				</Tabs>
				<BettoPrimaryButton variant="ghost" size="sm" onClick={handleAddMethod}>
					+ {translate("betto.profile.addNewMethod")}
				</BettoPrimaryButton>
			</TabBar>
			<BettoEmptyState title={translate("betto.profile.noCardYet")} />
		</BettoCard>
	);
});

PaymentMethodsSection.displayName = "PaymentMethodsSection";

PaymentMethodsSection.propTypes = {
	translate: PropTypes.func.isRequired,
	history: PropTypes.object,
};
